import React from 'react';
import { useHistory } from 'react-router-dom';

import './Logo.scss';

export const LogoHome = () => {
    const history = useHistory();

    return (
        <div
            className='logo2'
            style={{
                position: 'absolute',
                top: '0',
                left: '0',
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
            }}
            onClick={() => history.push('/diagrams')}
        >
            <span
                className="logo2-icon-text"
                aria-hidden="true"
                style={{
                    position: 'unset',
                    display: 'flex',
                    userSelect: 'none',
                }}
            >
                dbdesign
            </span>
        </div>
    );
};

export default LogoHome;
